module.exports = __webpack_public_path__ + "static/media/button-bg.9d498b99.svg";